module.exports = __webpack_public_path__ + "static/media/hmi_blog.33a3b653.jpg";